/* eslint-disable */
import * as React from "react";
import { SlideContext } from "../Context";
import { ComponentPreloader } from '../../../components/ComponentPreloader';
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart from '../../../../charts/components/HighchartsChart';
import { ComponentTitle } from "../../../components/ComponentTitle";
import { ComponentSourcetitle } from '../../../components/ComponentSourcetitle';

import { useGrowthChartTitle } from "../hooks/useGrowthChartTitle";
import { useChartGrowthData } from "../data/useChartGrowthtData";
import { useHighchartGrowthTransformer } from "../transformers/useHighchartGrowthTransformer";

export const ComponentChartGrowth: React.FC<{ context: SlideContext }> = (props) => {
  const context = props.context;
  const olapResult = useHookSubscribe(null, context.olapResult$);
  const parameters = useHookSubscribe(null, context.parameters);
  const loading = useHookSubscribe(null, context.loading$);
  const source = useHookSubscribe(null, context.sources$);

  const title = useGrowthChartTitle();
  
  const chartData = useChartGrowthData(olapResult);
  const highchartData = useHighchartGrowthTransformer(chartData, parameters);

  if (window['exportMode']) {
    window["exportReady"] = !loading;
  }

  if (loading) {
    return <ComponentPreloader />;
  }
  return <>
    <ComponentSourcetitle>Source: {source || 'USDA Prices'}</ComponentSourcetitle>
    <ComponentTitle>{title}</ComponentTitle>
    <HighchartsChart data={highchartData} loader={<ComponentPreloader />} />
  </>
};
